import { type CompletedSessions } from "@modules/completedSessions/completedSessionsType"

export interface CompletedSessionsDTO {
  beginDate: string
  endDate: string
  nbSessions: number
}

export function convertCompletedSessionsFromDto(dto: CompletedSessionsDTO): CompletedSessions {
  return {
    ...dto,
    beginDate: new Date(dto.beginDate),
    endDate: new Date(dto.endDate),
  }
}
